module.exports = __webpack_public_path__ + "static/media/gif1.4ca39be9.gif";